@let wizardHost = wizard();
@let ticketInfo = ticket();
<form [formGroup]="wizardHost.generalForm" class="flex flex-col gap-4">
  <label class="flex flex-col gap-2">
    <span class="text-sm font-semibold text-[#3d2652]">
      {{ "mobile.eachat.field.label" | translate }} <span class="text-destructive">*</span>
    </span>
    <input
      formControlName="label"
      type="text"
      maxlength="50"
      class="min-h-[48px] w-full rounded-xl border border-[#ece4f3] bg-white px-3 py-3 text-sm text-[#1a1523] placeholder:text-[#94a3b8] focus:border-[#5a2f6b]/40 focus:outline-none focus:ring-2 focus:ring-[#5a2f6b]/20"
      [placeholder]="'mobile.eachat.field.label.placeholder' | translate"
    />
    @if (wizardHost.generalForm.controls["label"].invalid && wizardHost.generalForm.controls["label"].touched) {
      <span class="text-xs text-destructive">{{ "mobile.eachat.validation.label" | translate }}</span>
    }
  </label>

  @if (wizardHost.ticketStatusList().length) {
    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs font-semibold text-[#7a6b8a]">{{ "mobile.eachat.field.status" | translate }}</span>
      <details
        #ticketStatusDd
        class="relative min-w-0 rounded-xl border border-[#ece4f3] bg-white shadow-sm [&_summary::-webkit-details-marker]:hidden"
      >
        <summary
          class="flex cursor-pointer list-none items-center justify-between gap-2 px-3 py-3 text-sm font-medium outline-none focus-visible:rounded-xl focus-visible:ring-2 focus-visible:ring-[#5a2f6b]/35"
        >
          <span class="flex min-w-0 flex-1 items-center gap-2.5">
            @if (wizardHost.ticketStatusSummary(); as ticketStatusSummaryInfo) {
              <span
                class="h-2.5 w-2.5 shrink-0 rounded-full ring-2 ring-black/5"
                [style.background-color]="ticketStatusSummaryInfo.color"
              ></span>
              <span class="min-w-0 truncate uppercase tracking-wide text-[#64748b]">{{ ticketStatusSummaryInfo.label }}</span>
            } @else {
              @if (ticketInfo.EntityStatus) {
                <span
                  class="h-2.5 w-2.5 shrink-0 rounded-full ring-2 ring-black/5"
                  [style.background-color]="wizardHost.mobileEntityStatusDotColor(ticketInfo.EntityStatus.ColorHexa ?? null)"
                ></span>
                <span class="min-w-0 truncate uppercase tracking-wide text-[#64748b]">{{ ticketInfo.EntityStatus.Label }}</span>
              } @else {
                <span class="truncate text-[#7a6b8a]">{{ "app.shared.select" | translate }}</span>
              }
            }
          </span>
          <span class="material-icons shrink-0 text-[22px] text-[#7a6b8a]" aria-hidden="true">expand_more</span>
        </summary>
        <div
          class="absolute left-0 right-0 top-full z-30 mt-1 max-h-[min(70vh,28rem)] overflow-y-auto overscroll-contain rounded-xl border border-[#ece4f3] bg-white py-1 shadow-lg"
          role="listbox"
        >
          @for (status of wizardHost.ticketStatusList(); track ticketStatusTrack($index, status)) {
            <button
              type="button"
              role="option"
              class="flex w-full min-w-0 items-center gap-2.5 px-3 py-2.5 text-left text-sm uppercase tracking-wide transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa]"
              [class.bg-[#f5f0fa]]="wizardHost.ticketSelectedStatusUidStr() === wizardHost.ticketStatusValue(status)"
              [class.font-semibold]="wizardHost.ticketSelectedStatusUidStr() === wizardHost.ticketStatusValue(status)"
              [class.text-[#5a2f6b]]="wizardHost.ticketSelectedStatusUidStr() === wizardHost.ticketStatusValue(status)"
              [class.text-[#64748b]]="wizardHost.ticketSelectedStatusUidStr() !== wizardHost.ticketStatusValue(status)"
              (click)="wizardHost.pickTicketStatus(status, ticketStatusDd)"
            >
              <span
                class="h-2.5 w-2.5 shrink-0 rounded-full ring-2 ring-black/5"
                [style.background-color]="wizardHost.ticketStatusRowDotColor(status)"
              ></span>
              <span class="min-w-0 flex-1 break-words">{{ status.Label }}</span>
            </button>
          }
        </div>
      </details>
    </div>
  } @else {
    @if (ticketInfo.EntityStatus; as entityStatusRow) {
      @if (entityStatusRow.Label) {
        <div class="flex min-w-0 flex-col gap-1">
          <span class="text-xs font-semibold text-[#7a6b8a]">{{ "mobile.eachat.field.status" | translate }}</span>
          <div
            class="relative w-full min-w-0 rounded-xl border border-[#ece4f3] bg-white shadow-sm"
            role="group"
          >
            <div
              class="flex min-h-[48px] w-full cursor-default select-none items-center justify-between gap-3 px-3 py-3 text-sm font-medium uppercase tracking-wide text-[#64748b]"
            >
              <span class="flex min-w-0 flex-1 items-center gap-2.5">
                <span
                  class="h-2.5 w-2.5 shrink-0 rounded-full ring-2 ring-black/5"
                  [style.background-color]="wizardHost.mobileEntityStatusDotColor(entityStatusRow.ColorHexa ?? null)"
                ></span>
                <span class="min-w-0 flex-1 truncate">{{ entityStatusRow.Label }}</span>
              </span>
              <span class="material-icons shrink-0 text-[22px] leading-none text-[#7a6b8a]" aria-hidden="true"
                >expand_more</span
              >
            </div>
          </div>
        </div>
      }
    }
  }

  @if (ticketInfo.TicketType; as ticketTypeRow) {
    @if (ticketTypeRow.Label?.trim(); as configuredTypeLabel) {
      <div class="flex min-w-0 flex-col gap-1">
        <span class="text-xs font-semibold text-[#7a6b8a]">
          {{ "app.ticket.type.notmodifiable" | translate }} <span class="text-destructive">*</span>
        </span>
        <div
          class="relative min-w-0 rounded-xl border border-[#ece4f3] bg-white shadow-sm"
          role="group"
          [attr.aria-label]="('app.ticket.type.notmodifiable' | translate) + ' — ' + configuredTypeLabel"
        >
          <div
            class="flex min-h-[48px] cursor-default select-none items-center justify-between gap-2 px-3 py-3 text-sm font-medium text-[#64748b]"
          >
            <span class="flex min-w-0 flex-1 items-center gap-2.5">
              <span
                class="h-2.5 w-2.5 shrink-0 rounded-full bg-[#94a3b8] ring-2 ring-black/5"
                aria-hidden="true"
              ></span>
              <span class="min-w-0 flex-1 truncate">{{ configuredTypeLabel }}</span>
            </span>
            <span class="material-icons shrink-0 text-[22px] text-[#7a6b8a]" aria-hidden="true">expand_more</span>
          </div>
        </div>
      </div>
    }
  }

  <div class="flex min-w-0 flex-col gap-1">
    <span class="text-sm font-semibold text-[#3d2652]">
      {{ "app.ticket.requester.select" | translate }} <span class="text-destructive">*</span>
    </span>
    <details
      #requesterDd
      class="relative min-w-0 rounded-xl border border-[#ece4f3] bg-white shadow-sm [&_summary::-webkit-details-marker]:hidden"
      (toggle)="wizardHost.onRequesterToggle($event)"
    >
      <summary
        class="flex cursor-pointer list-none items-center justify-between gap-2 px-3 py-3 text-sm font-medium text-[#3d2652] outline-none focus-visible:rounded-xl focus-visible:ring-2 focus-visible:ring-[#5a2f6b]/35"
        [attr.aria-invalid]="wizardHost.showRequesterError()"
      >
        <span class="flex min-w-0 flex-1 items-center gap-2.5">
          @if (wizardHost.hasRequester(ticketInfo)) {
            <span
              class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#5a2f6b] text-[0.65rem] font-bold text-white"
              aria-hidden="true"
              >{{ wizardHost.ticketRequesterInitials(ticketInfo) }}</span
            >
            <span class="min-w-0 flex-1 truncate font-medium">{{ wizardHost.mobileTicketRequesterLabel(ticketInfo) }}</span>
          } @else {
            <span class="h-2.5 w-2.5 shrink-0 rounded-full bg-[#5a2f6b] ring-2 ring-[#efe6f6]" aria-hidden="true"></span>
            <span class="truncate text-[#7a6b8a]">{{ wizardHost.requesterPlaceholderKey() | translate }}</span>
          }
        </span>
        <span class="material-icons shrink-0 text-[22px] text-[#7a6b8a]" aria-hidden="true">expand_more</span>
      </summary>
      <div
        class="absolute left-0 right-0 top-full z-30 mt-1 max-h-[min(70vh,28rem)] overflow-y-auto overscroll-contain rounded-xl border border-[#ece4f3] bg-white shadow-lg"
        role="listbox"
        (click)="$event.stopPropagation()"
      >
        <div class="sticky top-0 z-10 border-b border-[#ece4f3] bg-white p-2">
          <div class="flex gap-2">
            <input
              type="search"
              name="requesterSearch"
              class="min-w-0 flex-1 rounded-full border border-[#ece4f3] bg-[#faf7fc] px-3 py-2 text-sm text-[#3d2652] placeholder:text-[#a49db0]"
              [placeholder]="'app.shared.search' | translate"
              [ngModel]="wizardHost.requesterSearchSig()"
              (ngModelChange)="wizardHost.requesterSearchSig.set($event)"
              [ngModelOptions]="{ standalone: true }"
              autocomplete="off"
            />
            <button
              type="button"
              class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#ece4f3] bg-[#faf7fc] text-[#3d2652]"
              (click)="wizardHost.toggleRequesterSelectionMode(); $event.stopPropagation()"
              [attr.title]="
                wizardHost.requesterSelectionMode() === 'teams'
                  ? ('app.ticket.toggle.identities' | translate)
                  : wizardHost.requesterSelectionMode() === 'identities'
                    ? ('app.ticket.toggle.subdivisions' | translate)
                    : ('app.ticket.toggle.teams' | translate)
              "
            >
              <span class="material-icons text-[20px]" aria-hidden="true">{{ wizardHost.requesterModeToggleMaterialIcon() }}</span>
            </button>
          </div>
        </div>
        @if (wizardHost.requesterCatalogLoading()) {
          <div class="flex justify-center py-6">
            <span class="material-icons animate-spin text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
          </div>
        } @else {
          <div class="py-1">
            @if (wizardHost.requesterSelectionMode() === "teams") {
              @for (requesterTeam of wizardHost.filteredRequesterTeams(); track teamTrack($index, requesterTeam)) {
                <button
                  type="button"
                  role="option"
                  class="flex w-full min-w-0 items-center gap-2.5 px-3 py-2.5 text-left text-sm transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa]"
                  (click)="wizardHost.pickRequesterTeam(requesterTeam, requesterDd)"
                >
                  <span class="h-2.5 w-2.5 shrink-0 rounded-full bg-[#5a2f6b] ring-2 ring-[#efe6f6]"></span>
                  <span class="min-w-0 flex-1 break-words">{{ requesterTeam.Name }}</span>
                </button>
              }
            } @else if (wizardHost.requesterSelectionMode() === "identities") {
              @for (requesterIdentity of wizardHost.filteredRequesterIdentities(); track identityTrack($index, requesterIdentity)) {
                <button
                  type="button"
                  role="option"
                  class="flex w-full min-w-0 items-center gap-2.5 px-3 py-2.5 text-left text-sm transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa]"
                  (click)="wizardHost.pickRequesterIdentity(requesterIdentity, requesterDd)"
                >
                  <span class="h-2.5 w-2.5 shrink-0 rounded-full bg-[#5a2f6b] ring-2 ring-[#efe6f6]"></span>
                  <span class="min-w-0 flex-1 break-words">{{ wizardHost.identityRowLabel(requesterIdentity) }}</span>
                </button>
              }
            } @else {
              @for (requesterSubDivision of wizardHost.filteredRequesterSubDivisions(); track subDivisionTrack($index, requesterSubDivision)) {
                <button
                  type="button"
                  role="option"
                  class="flex w-full min-w-0 items-center gap-2.5 px-3 py-2.5 text-left text-sm transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa]"
                  (click)="wizardHost.pickRequesterSubDivision(requesterSubDivision, requesterDd)"
                >
                  <span class="h-2.5 w-2.5 shrink-0 rounded-full bg-[#5a2f6b] ring-2 ring-[#efe6f6]"></span>
                  <span class="min-w-0 flex-1 break-words">{{ requesterSubDivision.Name }}</span>
                </button>
              }
            }
            @if (
              !wizardHost.requesterCatalogLoading() &&
              (wizardHost.requesterSelectionMode() === 'teams'
                ? wizardHost.filteredRequesterTeams().length === 0
                : wizardHost.requesterSelectionMode() === 'identities'
                  ? wizardHost.filteredRequesterIdentities().length === 0
                  : wizardHost.filteredRequesterSubDivisions().length === 0)
            ) {
              <p class="px-3 py-4 text-center text-sm text-[#7a6b8a]">
                {{ "app.shared.no.results" | translate }}
              </p>
            }
          </div>
        }
      </div>
    </details>
    @if (wizardHost.showRequesterError()) {
      <span class="text-xs text-destructive">{{ "mobile.eachat.validation.requesterRequired" | translate }}</span>
    }
  </div>

  <div class="flex min-w-0 flex-col gap-1">
    <span class="text-sm font-semibold text-[#3d2652]">{{ "app.ticket.recipient.selectifdifferent" | translate }}</span>
    <details
      #recipientDd
      class="relative min-w-0 rounded-xl border border-[#ece4f3] bg-white shadow-sm [&_summary::-webkit-details-marker]:hidden"
      (toggle)="wizardHost.onRecipientToggle($event)"
    >
      <summary
        class="flex cursor-pointer list-none items-center justify-between gap-2 px-3 py-3 text-sm font-medium text-[#3d2652] outline-none focus-visible:rounded-xl focus-visible:ring-2 focus-visible:ring-[#5a2f6b]/35"
      >
        <span class="flex min-w-0 flex-1 items-center gap-2.5">
          @if (wizardHost.mobileTicketRecipientLabel(ticketInfo)) {
            <span class="h-2.5 w-2.5 shrink-0 rounded-full bg-[#5a2f6b] ring-2 ring-[#efe6f6]" aria-hidden="true"></span>
            <span class="min-w-0 flex-1 truncate">{{ wizardHost.mobileTicketRecipientLabel(ticketInfo) }}</span>
          } @else {
            <span class="h-2.5 w-2.5 shrink-0 rounded-full bg-[#c4b8d0] ring-2 ring-[#efe6f6]" aria-hidden="true"></span>
            <span class="truncate text-[#7a6b8a]">{{ wizardHost.recipientPlaceholderKey() | translate }}</span>
          }
        </span>
        <span class="material-icons shrink-0 text-[22px] text-[#7a6b8a]" aria-hidden="true">expand_more</span>
      </summary>
      <div
        class="absolute left-0 right-0 top-full z-30 mt-1 max-h-[min(70vh,28rem)] overflow-y-auto overscroll-contain rounded-xl border border-[#ece4f3] bg-white shadow-lg"
        role="listbox"
        (click)="$event.stopPropagation()"
      >
        <div class="sticky top-0 z-10 border-b border-[#ece4f3] bg-white p-2">
          <div class="flex gap-2">
            <input
              type="search"
              name="recipientSearch"
              class="min-w-0 flex-1 rounded-full border border-[#ece4f3] bg-[#faf7fc] px-3 py-2 text-sm text-[#3d2652] placeholder:text-[#a49db0]"
              [placeholder]="'app.shared.search' | translate"
              [ngModel]="wizardHost.recipientSearchSig()"
              (ngModelChange)="wizardHost.recipientSearchSig.set($event)"
              [ngModelOptions]="{ standalone: true }"
              autocomplete="off"
            />
            <button
              type="button"
              class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#ece4f3] bg-[#faf7fc] text-[#3d2652]"
              (click)="wizardHost.toggleRecipientSelectionMode(); $event.stopPropagation()"
              [attr.title]="
                wizardHost.recipientSelectionMode() === 'teams'
                  ? ('app.ticket.toggle.identities' | translate)
                  : ('app.ticket.toggle.teams' | translate)
              "
            >
              <span class="material-icons text-[20px]" aria-hidden="true">{{
                wizardHost.recipientSelectionMode() === "teams" ? "person" : "groups"
              }}</span>
            </button>
          </div>
        </div>
        @if (wizardHost.recipientCatalogLoading()) {
          <div class="flex justify-center py-6">
            <span class="material-icons animate-spin text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
          </div>
        } @else {
          <div class="py-1">
            @if (wizardHost.recipientSelectionMode() === "teams") {
              @for (recipientTeam of wizardHost.filteredRecipientTeams(); track teamTrack($index, recipientTeam)) {
                <button
                  type="button"
                  role="option"
                  class="flex w-full min-w-0 items-center gap-2.5 px-3 py-2.5 text-left text-sm transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa]"
                  (click)="wizardHost.pickRecipientTeam(recipientTeam, recipientDd)"
                >
                  <span class="h-2.5 w-2.5 shrink-0 rounded-full bg-[#5a2f6b] ring-2 ring-[#efe6f6]"></span>
                  <span class="min-w-0 flex-1 break-words">{{ recipientTeam.Name }}</span>
                </button>
              }
            } @else {
              @for (recipientIdentity of wizardHost.filteredRecipientIdentities(); track identityTrack($index, recipientIdentity)) {
                <button
                  type="button"
                  role="option"
                  class="flex w-full min-w-0 items-center gap-2.5 px-3 py-2.5 text-left text-sm transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa]"
                  (click)="wizardHost.pickRecipientIdentity(recipientIdentity, recipientDd)"
                >
                  <span class="h-2.5 w-2.5 shrink-0 rounded-full bg-[#5a2f6b] ring-2 ring-[#efe6f6]"></span>
                  <span class="min-w-0 flex-1 break-words">{{ wizardHost.identityRowLabel(recipientIdentity) }}</span>
                </button>
              }
            }
            @if (
              !wizardHost.recipientCatalogLoading() &&
              (wizardHost.recipientSelectionMode() === 'teams'
                ? wizardHost.filteredRecipientTeams().length === 0
                : wizardHost.filteredRecipientIdentities().length === 0)
            ) {
              <p class="px-3 py-4 text-center text-sm text-[#7a6b8a]">
                {{ "app.shared.no.results" | translate }}
              </p>
            }
            <div class="my-1 border-t border-[#ece4f3]"></div>
            <button
              type="button"
              role="option"
              class="flex w-full min-w-0 items-center gap-2.5 px-3 py-2.5 text-left text-sm text-[#3d2652] transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa]"
              (click)="wizardHost.clearRecipient(recipientDd)"
            >
              <span class="material-icons shrink-0 text-[20px] text-[#7a6b8a]" aria-hidden="true">folder_off</span>
              <span>{{ "app.shared.notprovided" | translate }}</span>
            </button>
          </div>
        }
      </div>
    </details>
  </div>

  <label class="flex flex-col gap-2">
    <span class="text-sm font-semibold text-[#3d2652]">{{ "mobile.eachat.field.comment" | translate }}</span>
    <textarea
      formControlName="description"
      rows="4"
      maxlength="250"
      class="w-full rounded-xl border border-[#ece4f3] bg-white px-3 py-3 text-sm text-[#1a1523] placeholder:text-[#94a3b8] focus:border-[#5a2f6b]/40 focus:outline-none focus:ring-2 focus:ring-[#5a2f6b]/20"
      [placeholder]="'mobile.eachat.field.comment.placeholder' | translate"
    ></textarea>
    <span class="text-right text-[0.7rem] text-[#94a3b8]">
      {{ wizardHost.descriptionCharsRemaining() }} {{ "mobile.eachat.wizard.charactersRemaining" | translate }}
    </span>
  </label>
</form>
